import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "reviewTools", "reviewInfo", "reviewButton", "infoButton"]

}
